import { Loader2 } from 'lucide-react';

export function SignupInvitationChecking() {
  return (
    <div className="bg-white rounded-lg border p-6 flex flex-col w-full sm:w-96 items-center justify-center gap-3 min-h-[200px]">
      <Loader2 className="h-6 w-6 animate-spin text-gray-900" />
      <p className="text-sm font-sans font-normal text-muted-foreground text-center">
        Validando seu link de cadastro...
      </p>
    </div>
  );
}
